import { Route, Routes } from "react-router-dom";
import "./MediaQuery.css";
import ItcPortal from "./pages/ItcPortal.jsx";

const App = () => {
  // console.log(process.env.REACT_APP_BASE_URL.toString());
  return (
    <div className="App">
      <Routes>
        <Route index={true} element={<ItcPortal />} />
      </Routes>
    </div>
  );
};

export default App;
